export default __webpack_public_path__ + "static/media/chart.4ad0f3fb.svg";